var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clear forgot-flow-footer"},[_c('div',{attrs:{"id":"vz-gf20"}})])
}]

export { render, staticRenderFns }